import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "md:flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center mb-3 md:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Komisi Kurir", -1)
const _hoisted_4 = { class: "grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4" }
const _hoisted_5 = { class: "container-card p-3" }
const _hoisted_6 = { class: "flex w-full items-center justify-between mb-3" }
const _hoisted_7 = { class: "grid grid-cols-3 gap-2 mb-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "pl-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-sm color-blue-grey-lighten-1" }, "Target")
], -1)
const _hoisted_9 = { class: " col-span-2" }
const _hoisted_10 = { class: "text-sm font-bold color-red" }
const _hoisted_11 = { class: "grid grid-cols-3 gap-2 items-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "pl-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-sm color-blue-grey-lighten-1" }, "Jenis Kendaraan")
], -1)
const _hoisted_13 = { class: " col-span-2" }
const _hoisted_14 = {
  key: 0,
  class: "font-bold text-subtitle2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_CourierComissionForm = _resolveComponent("CourierComissionForm")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, { class: "h-full px-2" }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Komisi",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari Disini ...",
              canClick: true,
              onSubmitInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData(_ctx.inputSearch))),
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (data) => {
            return (_openBlock(), _createBlock("div", {
              class: "grid-card-grey w-full",
              key: data.Id
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("p", {
                    class: ["font-bold hover-primary", _ctx.route.meta.permission.update ? 'cursor-pointer' : ''],
                    onClick: ($event: any) => (_ctx.route.meta.permission.update ? _ctx.detailData(data) : function(){})
                  }, _toDisplayString(data?.MsKota?.Nama), 11, ["onClick"]),
                  _createVNode("i", {
                    class: "pi pi-ellipsis-h",
                    onClick: ($event: any) => (_ctx.showDropDown($event, data))
                  }, null, 8, ["onClick"])
                ]),
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("div", _hoisted_9, [
                    _createVNode("p", _hoisted_10, _toDisplayString(data.Target) + " resi", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("div", _hoisted_13, [
                    (data.MsKomisiKurirJenisKendaraans?.length > 0)
                      ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(data.MsKomisiKurirJenisKendaraans.map(val => val.MsJenisKendaraan.Nama).join()), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          del: _ctx.route.meta.permission.delete,
          edit: _ctx.route.meta.permission.update,
          onDel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteData(_ctx.dataForm.Id))),
          onEdit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editData(_ctx.dataForm)))
        }, null, 8, ["del", "edit"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CourierComissionForm, {
          dataEdit: _ctx.dataForm,
          onReloadData: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getAllDataCourierComission())),
          onCloseSidebar: _ctx.closeSidebar
        }, null, 8, ["dataEdit", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}